module.exports = __webpack_public_path__ + "img/vc.fc6aa8fe.svg";